export default __webpack_public_path__ + "static/media/welcome.0d879a2e.png";